import { render, staticRenderFns } from "./contact-us-phone.vue?vue&type=template&id=2d04468d&scoped=true&"
import script from "./contact-us-phone.vue?vue&type=script&lang=js&"
export * from "./contact-us-phone.vue?vue&type=script&lang=js&"
import style0 from "./contact-us-phone.vue?vue&type=style&index=0&id=2d04468d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d04468d",
  null
  
)

export default component.exports